import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';
import { queryClient } from '../../queryClient';

interface HookProps {
  batchId: string;
  fileName: string;
}

export const useGenerateInvoice = () => {
  return useMutation({
    mutationFn: async ({ batchId }: HookProps) => {
      const result = await apiClient.batchesReports.generateInvoice.mutation({ body: { batchId } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserReports'] });
      toast.success('The invoice is being generated. It will be downloaded when ready!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the report!');
    },
  });
};
